import merge from 'deepmerge'
import KinvaCrudRoutes from './KinvaCrudRoutes'
import KinvaCustomRoutes from './KinvaCustomRoutes'

const routes = merge.all([KinvaCrudRoutes, KinvaCustomRoutes])


export default routes;

